export default __webpack_public_path__ + "static/media/memberbg.17355066.jpg";